import React from 'react';
import GetNow from '../components/license-buy/GetNow';
import ContactForm from '../components/license-buy/ContactForm';
import BackButton from '../components/BackButton';
import UpgradePromoBlock from '../components/UpgradePromoBlock';
import { useLicenseCheck } from '../hooks/useLicenseCheck';
import { RootState } from '../store/store';
import { useSelector } from 'react-redux';
import HowItWorks from '../components/license-buy/HowItWorks';
import LicenseBuyCards from '../components/license-buy/LicenseBuyCards';

const MobileAppLicensePage = () => {
  const hasPaidLicense = useLicenseCheck('mobile');
  const profile = useSelector((state: RootState) => state.profile);

  return (
    <div className="license-buy-page">
      <BackButton />

      {profile && !profile.contact?.parentUserId && !hasPaidLicense && (
        <UpgradePromoBlock pluginName="mobile" />
      )}

      <HowItWorks licenseType={"mobile"} />

      <LicenseBuyCards
        licenseType={"mobile"}
      />

      <GetNow licenseType={"mobile"} />

      <ContactForm licenseType={"mobile"} />
    </div>
  );
};

export default MobileAppLicensePage;
